import axios from "axios";
import https from "https";
import authService from "@services/authService.js";

// import store from "@/store";

axios.defaults.baseURL = process.env.VUE_APP_URL_API;
axios.defaults.timeout = 30000;



const DEFAULT_HEADERS = () => ({
    'Authorization': 'Bearer ' + localStorage.getItem('apiToken'),
    'X-XSRF-TOKEN': 'webbuilder-design',
});

const agent = new https.Agent({
    rejectUnauthorized: false
});

export function getCancelToken() {
    const CancelToken = axios.CancelToken;
    return CancelToken.source();
}


/*
 * Returns default headers listt
 * which will be used with every request.
 */
function getHeaders(header = {}) {
    return { ...DEFAULT_HEADERS(), ...header };
}

/**
 * Make url endpoint
 * @param {*} endpoint
 */
function getUrl(url) {
    return process.env.VUE_APP_URL_API + url;
}

/*
 * Wraps axios and provides
 * more convenient post method
 * calls with data
 */
export async function post(url, data = {}, header = {}, options = {}) {
    // return await axios.post(getUrl(url), data, {
    //     headers: getHeaders(header),
    //     httpsAgent: agent,
    //     ...options,
    //     cancelToken: options.cancelToken && options.cancelToken.token,
    // });
    return new Promise((resolve, reject) => {
        const apiToken = localStorage.getItem('apiToken');
        axios.post(getUrl(url), data, {
            headers: getHeaders(header),
            httpsAgent: agent,
            ...options,
            cancelToken: options.cancelToken && options.cancelToken.token,
        }).then(response => {
            resolve(response)
        }).catch(async (error) => {
            if (error.message === 'CANCEL') {
                reject(error)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_EXPIRED") {
                if (apiToken == localStorage.getItem('apiToken')) {
                    await reToken()
                }
                const newRequest = post(url, data, header, options)
                resolve(newRequest)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_INVALID") {
                alert('01: token invalid');
                reject(error)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_EMPTY") {
                alert('02: no token');
                reject(error)
            } else {
                reject(error)
            }
        })

    })
}


/*
 * Wraps axios and provides
 * more convenient put method
 * calls with data
 */

/**
 * @param {*} url
 * @param {*} data
 */

export async function put(url, data = {}) {
    // return await axios.put(getUrl(url), data, {
    //     headers: getHeaders(),
    //     httpsAgent: agent
    // });
    return new Promise((resolve, reject) => {
        const apiToken = localStorage.getItem('apiToken');
        axios.put(getUrl(url), data, {
            headers: getHeaders(),
            httpsAgent: agent,
        }).then(response => {
            resolve(response)
        }).catch(async (error) => {
            if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_EXPIRED") {
                if (apiToken == localStorage.getItem('apiToken')) {
                    await reToken()
                }
                const newRequest = put(url, data)
                resolve(newRequest)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_INVALID") {
                alert('01: token invalid');
                reject(error)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_EMPTY") {
                alert('02: no token');
                reject(error)
            } else {
                reject(error)
            }
        })

    })
}

/**
 * @param {*} url
 * @param {*} data
 */

export async function patch(url, data = {}) {
    // return await axios.patch(getUrl(url), data, {
    //     headers: getHeaders(),
    //     httpsAgent: agent
    // });
    return new Promise((resolve, reject) => {
        const apiToken = localStorage.getItem('apiToken');
        axios.patch(getUrl(url), data, {
            headers: getHeaders(),
            httpsAgent: agent,
        }).then(response => {
            resolve(response)
        }).catch(async (error) => {
            if(error.toJSON().message === 'Network Error') {
                reject(error)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_EXPIRED") {
                if (apiToken == localStorage.getItem('apiToken')) {
                    await reToken()
                }
                const newRequest = patch(url, data)
                resolve(newRequest)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_INVALID") {
                alert('01: token invalid');
                reject(error)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_EMPTY") {
                alert('02: no token');
                reject(error)
            } else {
                reject(error)
            }
        })

    })
}

/*
 * Wraps axios and provides
 * more convenient delete method
 */
export async function remove(url, data = {}) {
    // return await axios.delete(getUrl(url),
    //     {
    //         headers: getHeaders(),
    //         httpsAgent: agent,
    //         data: data
    //     });
    return new Promise((resolve, reject) => {
        const apiToken = localStorage.getItem('apiToken');
        axios.delete(getUrl(url), {
            headers: getHeaders(),
            httpsAgent: agent,
            data: data,
        }).then(response => {
            resolve(response)
        }).catch(async (error) => {
            if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_EXPIRED") {
                if (apiToken == localStorage.getItem('apiToken')) {
                    await reToken()
                }
                const newRequest = remove(url, data)
                resolve(newRequest)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_INVALID") {
                alert('01: token invalid');
                reject(error)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_EMPTY") {
                alert('02: no token');
                reject(error)
            } else {
                reject(error)
            }
        })

    })
}

/*
 * Wraps axios and provides
 * more convenient get method
 * calls with data.
 */
export async function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        const apiToken = localStorage.getItem('apiToken');
        axios.get(getUrl(url), {
            params: params,
            cancelToken: params.cancelToken && params.cancelToken.token,
            headers: getHeaders(),
            httpsAgent: agent,
        }).then(response => {
            resolve(response)
        }).catch(async (error) => {
            if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_EXPIRED") {
                if (apiToken == localStorage.getItem('apiToken')) {
                    await reToken()
                }
                const newRequest = get(url, params)
                resolve(newRequest)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_INVALID") {
                alert('01: token invalid');
                reject(error)
            } else if (error.response.data.error == "ERROR_AUTHORIZATION_TOKEN_EMPTY") {
                alert('02: no token');
                reject(error)
            } else {
                reject(error)
            }
        })

    })

}

const reToken = function () {
    const processing = localStorage.getItem('processing');
    if(processing == 'false' || processing == null || processing == undefined) {
        localStorage.setItem("processing", true);
        return new Promise((resolve, reject) => {
            authService.refreshToken().then(response => {
                localStorage.setItem("apiToken", response.accessToken);
                localStorage.setItem("refreshToken", response.refreshToken);
                localStorage.setItem("processing", false);
                resolve(response)
            }).catch(error => {
                localStorage.setItem("processing", false);
                if (error.response.data.error == "ERROR_AUTHORIZATION_LOGIN_EXPIRED") { // Data is invalided.
                    alert('03: token expired');
                    logout()
                    reject(error)
                } else {
                    if(error.response.statusText == 'Internal Server Error') {
                        return axios.request(error.response.config);
                    }
                }
            })
        })
    }else {
        return new Promise(resolve => {
            let myInterval = setInterval(() => {
                const processing2 = localStorage.getItem('processing');
                if(processing2 == 'false') {
                    resolve('resolved');
                    clearInterval(myInterval);
                }
            } , 100);
        });
    }
}

const logout = function () {
    window.location.href = '/logout';
}
